import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMeweComponent } from './simple-icons-mewe.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMeweComponent ],
    exports:      [ SimpleIconsMeweComponent ],
    bootstrap:    []
})
export class SimpleIconsMeweModule {}
